export default "__VITE_ASSET__B7Qu5Q8p__"